import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import arrowIcon from "@iconify/icons-mdi/arrow-right";
import { InlineIcon } from "@iconify/react";
import { OcCustomTooltip } from "oc/components";

interface RowType {
  dayType: string;
  myTimeType: string | null;
  date: string;
}

export const OcDataTableBodyCellArrowIconIsNotExaminer = ({
  row,
  currentMonth,
  isNotExaminer,
  buttonStyle,
  periodMonth,
}: {
  row: RowType;
  currentMonth: string;
  isNotExaminer: boolean;
  buttonStyle: React.CSSProperties;
  periodMonth: string;
}) => {
  const { t } = useTranslation();
  if (currentMonth !== periodMonth) return null;
  if (
    !isNotExaminer ||
    (row?.dayType === "REST_DAY" && row?.myTimeType === null)
  ) {
    return null;
  } else {
    return (
      <OcCustomTooltip title={t("OC_NOT_SET_EXAMINER_INFO")} placement="top">
        <Box style={buttonStyle}>
          <InlineIcon
            width="24px"
            height="24px"
            id={`show-${new Date(row?.date).getDate()}`}
            icon={arrowIcon}
          />
        </Box>
      </OcCustomTooltip>
    );
  }
};

export default OcDataTableBodyCellArrowIconIsNotExaminer;
